import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const GrayDarkerServiceSpan = styled.span`
  color: ${(props) => props?.color};
  position: relative;
  font-weight: ${(props) => (props?.weight ? props.weight : "400")};
  ::before {
    position: absolute;
    content: "";
    display: block;
    height: 60px;
    width: 30px;
    left: -36px;
    background: radial-gradient(circle, #0a4986 10%, transparent 10%), 8px;
    background-size: 40px 20px;
    background-repeat: no-repeat;
  }
`;

export const GrayDarkerSpan = styled.span`
  color: ${(props) => (props?.color ? props.color : "#474747")};
  font-weight: ${(props) => (props?.weight ? props.weight : "400")};
  text-align: ${(props) => (props?.textAlign ? props.textAlign : "left")};
`;

export const GraySpan = styled.span`
  color: #767676;
  text-align: ${(props) => (props?.textAlign ? props.textAlign : "left")};
  justify-self: ${(props) => (props?.textAlign ? props.textAlign : "left")};
`;

export const MarginDiv = styled.section`
  margin-left: ${(props) => (props?.marginLeft ? props.marginLeft : "0px")};
  margin-top: ${(props) => (props?.marginTop ? props.marginTop : "0px")};
`;
